import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import emailjs from "emailjs-com";

const serviceID = "service_j2wrsd8";
const templateID = "template_9ikw4ct";
const userID = "user_fVbw4e59tnD3yXL1pPl6k";

function ContactForm() {
  //const [sentEmail, setSentEmail] = useState(false);

  const [contactParams, setParams] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  function handleInputChange(e) {
    const { name, value } = e.target;

    //setSentEmail(false);

    setParams((previousValues) => {
      return {
        ...previousValues,
        [name]: value,
      };
    });
  }

  function handleContactSubmit(e) {
    emailjs.send(serviceID, templateID, contactParams, userID).then(
      (response) => {
        //setSentEmail(true);
        setParams({
          name: "",
          email: "",
          message: "",
        });
      },
      (err) => {
        console.log("FAILED...", err);
      }
    );
    e.preventDefault();
  }

  return (
    <Form className="home-contact-form">
      <Form.Group controlId="firstName">
        <Form.Control
          placeholder="First Name"
          onChange={handleInputChange}
          name="firstName"
        />
      </Form.Group>

      <Form.Group controlId="lastName">
        <Form.Control
          placeholder="Last Name"
          onChange={handleInputChange}
          name="lastName"
        />
      </Form.Group>

      <Form.Group controlId="email">
        <Form.Control
          type="email"
          placeholder="Email"
          onChange={handleInputChange}
          name="email"
        />
      </Form.Group>

      <Form.Group controlId="message">
        <Form.Control
          as="textarea"
          rows={5}
          placeholder="Message"
          onChange={handleInputChange}
          name="message"
        />
      </Form.Group>

      <div className="text-center">
        <Button
          className="home-recipes-btn"
          size="lg "
          variant="primary"
          type="submit"
          onClick={handleContactSubmit}
        >
          Submit
        </Button>
      </div>
    </Form>
  );
}

export default ContactForm;
